import { Landing } from "../pages/landing/Landing";
import { Blog } from "../pages/blog/Blog";
import { PostDetails } from "../pages/blog/PostDetails";

export const guestRoutes = [
  {
    path: "/",
    component: <Landing />,
  },
  {
    path: "/blog",
    component: <Blog />,
  },
  {
    path: "/blog/post",
    component: <PostDetails />,
  },
];
